import { watchFetchLogisticsSyncChanges } from './fetchLogisticsSyncChanges';

export const logisticsSyncChangesSagas = [watchFetchLogisticsSyncChanges()];
